import { ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import { Home }                                 from "@material-ui/icons";
import * as React                               from "react";
import { FC, SFC }                              from "react";
import { useDispatch }                          from "react-redux";
import MenuType                                 from "../../../domain/menu/MenuType";
import RouterDispatcher                         from "../../../infrastructure/redux/router/RouterDispatcher";
import "./MenuList.scss";

interface Props {
  menuType: MenuType;
}

const MenuListNoticeButton: FC<Props> = (props: Props) => {
  const routerDispatcher: RouterDispatcher = new RouterDispatcher(useDispatch());
  const {menuType} = props;
  return (
    <>
      {
        menuType === MenuType.NOTICE
          ?
          <section className="reska-menu-selected">
            <ListItem button={ true } divider={ true } onClick={ () => routerDispatcher.notice() }>
              <ListItemIcon>
                <Home/>
              </ListItemIcon>
              <ListItemText primary="お知らせ" className="reska-menu-selected-text"/>
            </ListItem>
          </section>
          :
          <ListItem button={ true } divider={ true } onClick={ () => routerDispatcher.notice() }>
            <ListItemIcon>
              <Home/>
            </ListItemIcon>
            <ListItemText primary="お知らせ"/>
          </ListItem>
      }
    </>
  );
};

export default MenuListNoticeButton;
